/* FRONTEND: Internationalisation to implement */

const I18n = {}
export const tr = function ($str, $ns) {
  return $str
}

I18n.install = function (Vue, options) {
  Vue.prototype.$tr = tr
}

export default I18n



// WEBPACK FOOTER //
// ./src/plugins/i18n.js